/*
 * Chicken Fat: cart drawer copy and extras on top of Horizon's cart drawer.
 *
 * Horizon re-renders the drawer (snippets/cart-drawer.liquid) through the
 * Section Rendering API and morphs it in place, so anything written into it
 * gets reset on each cart change. Instead of editing Horizon's snippets, this
 * watches the drawer and re-applies our text after every re-render:
 *   - heading "Your cart (n)" (the brackets come from cf-theme.css)
 *   - aqua "Added…" banner after an add-to-cart, until the drawer closes
 *   - empty state: headphones mascot, message, button to the Shop page
 *   - "Subtotal" label, taxes note, "Continue shopping" link
 * The text comes from the "CF Cart drawer text" section (#cf-cart-copy).
 * Every write checks the current value first, so the observer settles.
 */
(function () {
  'use strict';

  var DEFAULTS = {
    title: 'Your cart',
    banner: 'Added. Your table is about to get loud.',
    emptyText: 'Your cart is quieter than a library.',
    emptyButton: 'Shop the game',
    shopUrl: '/products/chicken-fat-the-party-card-game',
    mascot: '',
    mascotAlt: 'Chicken Fat mascot wearing headphones',
    subtotal: 'Subtotal',
    taxes: 'Taxes and shipping calculated at checkout.',
    continueLabel: 'Continue shopping',
    fallbackThumb: ''
  };

  var showBanner = false;

  function getCopy() {
    var copy = {};
    var key;
    for (key in DEFAULTS) copy[key] = DEFAULTS[key];
    var el = document.getElementById('cf-cart-copy');
    if (!el) return copy;
    try {
      var data = JSON.parse(el.textContent);
      for (key in data) {
        if (typeof data[key] === 'string' && data[key].trim() !== '') copy[key] = data[key];
      }
    } catch (e) {
      /* keep the defaults */
    }
    return copy;
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setAttr(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  /* The drawer heading is "Cart" followed by the count badge; swap the word. */
  function setHeading(heading, text) {
    if (!heading) return;
    for (var node = heading.firstChild; node; node = node.nextSibling) {
      if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
        if (node.nodeValue.trim() !== text) node.nodeValue = text + ' ';
        return;
      }
    }
  }

  function enhance(dialog) {
    var copy = getCopy();
    var inner = dialog.querySelector('.cart-drawer__inner');
    if (!inner) return;
    var isEmpty = inner.classList.contains('cart-drawer--empty') || !!inner.querySelector('[data-cart-drawer-empty]');

    // Heading (filled cart)
    setHeading(dialog.querySelector('.theme-drawer__header .theme-drawer__title'), copy.title);

    // Empty state
    var emptyHeading = inner.querySelector('.cart-drawer__content > .theme-drawer__title');
    if (emptyHeading) {
      setText(emptyHeading, copy.emptyText);
      var mascot = emptyHeading.previousElementSibling;
      if (!mascot || !mascot.classList.contains('cf-cart-empty__mascot')) {
        mascot = document.createElement('img');
        mascot.className = 'cf-cart-empty__mascot';
        mascot.width = 160;
        mascot.height = 160;
        emptyHeading.parentNode.insertBefore(mascot, emptyHeading);
      }
      setAttr(mascot, 'src', copy.mascot);
      setAttr(mascot, 'alt', copy.mascotAlt);
      mascot.hidden = !copy.mascot;
    }
    var emptyButton = inner.querySelector('.cart-items__empty-button');
    if (emptyButton) {
      setAttr(emptyButton, 'href', copy.shopUrl);
      setText(emptyButton.querySelector('.button-text'), copy.emptyButton);
    }

    // Products with no image of their own get the box image on its tile
    if (copy.fallbackThumb) {
      inner.querySelectorAll('.cart-items__media').forEach(function (cell) {
        if (cell.children.length) return;
        var row = cell.closest('.cart-items__table-row');
        var link = row && row.querySelector('a[href*="/products/"]');
        var a = document.createElement('a');
        a.className = 'cart-items__media-container';
        a.style.setProperty('--ratio', '1');
        a.href = link ? link.getAttribute('href') : copy.shopUrl;
        a.setAttribute('aria-hidden', 'true');
        a.tabIndex = -1;
        var img = document.createElement('img');
        img.className = 'cart-items__media-image';
        img.src = copy.fallbackThumb;
        img.alt = '';
        a.appendChild(img);
        cell.appendChild(a);
      });
    }

    // Summary
    setText(inner.querySelector('.cart-totals__total-label'), copy.subtotal);
    setText(inner.querySelector('.cart-totals__tax-note small'), copy.taxes);
    var ctas = inner.querySelector('.cart-drawer__summary .cart__ctas');
    if (ctas) {
      var next = ctas.nextElementSibling;
      if (!next || !next.classList.contains('cf-cart-continue')) {
        next = document.createElement('button');
        next.type = 'button';
        next.className = 'cf-cart-continue';
        next.setAttribute('data-cf-cart-continue', '');
        ctas.parentNode.insertBefore(next, ctas.nextSibling);
      }
      setText(next, copy.continueLabel);
    }

    // "Added" banner, under the drawer header
    var banner = inner.querySelector('.cf-cart-banner');
    if (showBanner && !isEmpty) {
      var header = inner.querySelector('.theme-drawer__header');
      if (!banner && header) {
        banner = document.createElement('p');
        banner.className = 'cf-cart-banner';
        banner.setAttribute('role', 'status');
        header.parentNode.insertBefore(banner, header.nextSibling);
      }
      setText(banner, copy.banner);
    } else if (banner) {
      banner.remove();
    }
  }

  function init() {
    var drawer = document.getElementById('cart-drawer');
    var dialog = drawer && drawer.querySelector('dialog');
    if (!dialog) return;

    enhance(dialog);

    new MutationObserver(function () {
      enhance(dialog);
    }).observe(dialog, { childList: true, subtree: true, characterData: true });

    // Banner shows after a successful add and clears when the drawer closes.
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.action !== 'add') return;
      Promise.resolve(event.promise)
        .then(function (result) {
          if (result && result.detail && result.detail.didError) return;
          showBanner = true;
          enhance(dialog);
        })
        .catch(function () {});
    });

    dialog.addEventListener('close', function () {
      if (!showBanner) return;
      showBanner = false;
      enhance(dialog);
    });

    dialog.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cf-cart-continue]')) return;
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        dialog.close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
